export default "__VITE_ASSET__a466572b__"